import type { SVGProps } from "react";

export function IconVideoPause(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      aria-hidden="true"
      fill="white"
      viewBox="0 0 30 38"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Video pause</title>
      <rect height="37" rx="2.667" width="7.5" x="0" y="0.5" />
      <rect height="37" rx="2.667" width="7.5" x="17.5" y="0.5" />
    </svg>
  );
}
